import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Payment from './modals/Payment';
import reportWebVitals from './reportWebVitals';
import ToolTip from '@tuva-ui/components/src/ToolTip';
import { TuvaToastContainer } from '@tuva-ui/components/src/TuvaToast/TuvaToast';

const modalsRoot = document.getElementById('common-modals-root');
if (modalsRoot) {
  ReactDOM.createRoot(modalsRoot).render(
    <React.StrictMode>
      <App />
      <TuvaToastContainer />
      <ToolTip id="tuva-tooltip-id" />
    </React.StrictMode>,
  );
}

// The payment page (/payment/) renders inline rather than as a modal — Django
// hands over the Stripe/captcha keys and the prefilled user details on the div.
const paymentRoot = document.getElementById('payment-root');
if (paymentRoot) {
  ReactDOM.createRoot(paymentRoot).render(
    <React.StrictMode>
      <Payment
        stripeKey={paymentRoot.dataset.stripeKey}
        captchaKey={paymentRoot.dataset.captchaKey}
        email={paymentRoot.dataset.email}
        fullName={paymentRoot.dataset.fullName}
      />
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
